export default __webpack_public_path__ + "static/media/edit.1467d3b4.svg";